export default __webpack_public_path__ + "static/supportImg2-e44153f9071ba6f7169460e8e78a2f85.png";